import { isNull, get } from "lodash"
import locales from "./../../../content.json";

import bed from "./img/bed.png";
import sleep from "./img/sleep.png";
import sleep2 from "./img/sleep2.png";
import superhero from "./img/superhero.png";

export const checkIsValidCurrentActivity = data => {
    return validateCurrentStep(get(data, ["sleep", "value"], "")) && !data.sleep.isValid
}

export const validateCurrentStep = value => {
    return !isNull(value)
}

export const staticData = {
    0: {
        value: "5",
        title: locales[window.userLang].sleep_step_1,
        icon: sleep,
    },
    1: {
        value: "5-6",
        title: locales[window.userLang].sleep_step_2,
        icon: bed,
    },
    2: {
        value: "7-8",
        title: locales[window.userLang].sleep_step_3,
        icon: sleep2,
    },
    3: {
        value: "8+",
        title: locales[window.userLang].sleep_step_4,
        icon: superhero,
    },
}